import { Storage } from 'aws-amplify';
import uuid from "react-uuid";


async function S3UploadHook(file,path,setprogressCount, exam) {
    const body = {
        "content_type":"image/*",
        "file_path":path,
        "file_name": file.name
    }
    const key = `${path}/${uuid()}/${file.name}`;
    
    try {
        const result = await Storage.put(exam !== undefined ? path : key,file, {
            contentType: file.type,
            level:'public',
            progressCallback(progress) {
                setprogressCount(parseInt((progress.loaded/progress.total)*100))
            }
                
        },);
        // downloadS3Object(result.key) //Download example
        return result.key
    } catch (error) {
        console.log(error)

    }
   
}

export default S3UploadHook;